import { render, staticRenderFns } from "./config-table.vue?vue&type=template&id=276e604a&scoped=true"
import script from "./config-table.vue?vue&type=script&lang=js"
export * from "./config-table.vue?vue&type=script&lang=js"
import style0 from "./config-table.vue?vue&type=style&index=0&id=276e604a&prod&scoped=true&lang=scss"
import style1 from "./config-table.vue?vue&type=style&index=1&id=276e604a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e604a",
  null
  
)

export default component.exports